module.exports = __webpack_public_path__ + "components/country-flag/static/cc-e1a8e245eb16ed2b6078ca235e991696.svg";